import type { UrlFilterOption } from './useUrlFilterTools';

/** Ids → the labels the filter bar shows, for a surface's `filters` context. */
export function labelsFor(
  ids: string[] | undefined,
  options: UrlFilterOption[] | undefined,
): string | undefined {
  if (!ids?.length) return undefined;
  return ids
    .map((id) => options?.find((o) => o.id === id)?.label ?? id)
    .join(', ');
}
